import { Badge } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";

type TryBadgeProps = {
  featureId: string;
};

/**
 * Surface Radix Badge on the skill card (more contrast than soft). Not
 * interactive — the card button opens the walkthrough while Try is showing,
 * so this must not be a nested button. Absolute top-right so it rides the
 * card hover translate.
 */
export function TryBadge({ featureId }: TryBadgeProps) {
  const { t } = useTranslation("ui");

  return (
    <Badge
      size="1"
      variant="surface"
      color="blue"
      data-testid={`ask-puntt-try-badge-${featureId}`}
      className="absolute right-2 top-2 z-10"
    >
      {t("tryWalkthrough.badge")}
    </Badge>
  );
}
